import { z } from 'zod';
import { useRequirementSchema } from './useRequirement';
import { Combinator } from '../types';

export const useCriteriaSchema = () => {
  const requirementSchema = useRequirementSchema();
  return z.object({
    combinator: z.nativeEnum(Combinator),
    searchQueries: z.array(requirementSchema),
  });
};
